import { Chip, Grid, Typography } from "@mui/material";
import {
  MonitorErrorCodeEnum,
  MonitorErrorCodeMessages,
} from "../../../models/dto/ws/monitoring/MonitorErrorCodeEnum";

interface Props {
  errorCode: MonitorErrorCodeEnum;
}

const Warning = (props: Props) => {
  return (
    <>
      <Grid
        item
        xs={6}
        sm={6}
        sx={{
          alignItems: "center",
          justifyContent: "flex-start",
          display: "flex",
        }}
      >
        <Typography>Warning </Typography>
      </Grid>
      <Grid
        item
        xs={6}
        sm={6}
        sx={{
          alignItems: "center",
          justifyContent: "flex-end",
          display: "flex",
        }}
      >
        <Chip
          label={MonitorErrorCodeMessages[props.errorCode] ?? `Unknown (${props.errorCode})`}
          variant="outlined"
          color={
            props.errorCode !== MonitorErrorCodeEnum.NO_ERROR
              ? "error"
              : "success"
          }
        />
      </Grid>
    </>
  );
};

export { Warning };
